<app-main-navigation></app-main-navigation>
<div class="container-fluid">
    <app-price-graphs></app-price-graphs>
</div>
